import { DefaultApi, Configuration } from "../services";
import handleUnauthorized from "./middleware";

const basePath = process.env.REACT_APP_BASE_PATH || "http://localhost:3000";
const getToken = () => {
  return localStorage.getItem("authToken");
};

const apiConfig = new Configuration({
  basePath: basePath,
  credentials: "include",
  accessToken: () => {
    const token = getToken();
    return token ? Promise.resolve(token) : Promise.resolve("");
  },
  middleware: [handleUnauthorized],
});

const apiClient = new DefaultApi(apiConfig);

const apiConfigWithoutMiddleWare = new Configuration({
  basePath: basePath,
  credentials: "include",
  accessToken: () => {
    const token = getToken();
    return token ? Promise.resolve(token) : Promise.resolve("");
  },
});

const apiClientWithoutMiddleWare = new DefaultApi(apiConfigWithoutMiddleWare);

export { basePath, apiClientWithoutMiddleWare };

export default apiClient;
